module.exports = __webpack_public_path__ + "72092289603029ba904f31ac01950b7a.fbx";